import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { USER_ROLE } from 'config/constants';
import ProfitWell from 'components/ProfitWell';
// This Higher Order Component allows us to wrap
// authentication functionality around our component
//
// to perform authentication on a component it the routes file
// import Authentication   // this HOC
// import Feature          // the component which requires authentication
//
// <Route path="feature" component={ Authentication(Feature) } />

// ComponentToWrap is the component we want to Authenticate
export default (landingPage) => (ComponentToWrap) => {
  class Authentication extends Component {
    static get contextTypes() {
      return {
        router: PropTypes.object,
      };
    }

    // called when the component is first rendered
    componentWillMount() {
      // if the user is not authenticated, redirect to /
      this.handleRoute();
    }

    // TODO: This componentDidUpdate is horrible design. Everytime a component
    // updates we have this massive function above that computes the right place
    // for the user to be. However this means that if you're trying to control
    // where the app goes in an onSubmit handler or some other place in the app
    // your control may be hijacked and this creates a ton of confusion for the
    // developer. I'm open to being wrong and maybe this needs a second pair of eyes
    // but this needs to be addressed during the OnSched rewrite and you can see
    // above that handleRoute is already becoming a mess

    // called when the component state is updated and the
    // component is about to be handed a new set of props
    componentDidUpdate() {
      // if the user is not authenticated, redirect to /
      this.handleRoute();
    }

    doesUserHaveAnActiveTrial = () => {
      const { user } = this.props;
      const { trialStatus } = user.profile;
      return (
        trialStatus &&
        trialStatus.status === 'credit_trial' &&
        trialStatus.creditsRemaining < trialStatus.maxCredits
      );
    };

    doesUserHaveASubscription = () => {
      const { user } = this.props;
      const { live_subscription } = user.profile;
      return live_subscription != null;
    };

    canUserUpsell = () => {
      const { user } = this.props;
      return get(user, 'upsellData.upsellPlan', null) != null;
    };

    handleRoute = () => {
      const { location, user } = this.props;

      const isActivatePage = location.pathname.indexOf('/activate') !== -1;
      const isBookingPage =
        location.pathname.indexOf('/schedule-lesson') !== -1;
      const isReactivatePage = location.pathname.indexOf('/reactivate') !== -1;
      const isSuccessPage = location.pathname.indexOf('/success') !== -1;
      const isAdminPage = location.pathname.indexOf('/admin') !== -1;
      const isAdmin = user.profile && user.profile.role === 'admin';
      const isConfirmLessonPage = location.pathname.indexOf('/confirm-lesson') !== -1;
      const isPaused = !!user.profile.pause;

      // let route = "/";
      let route = location.pathname;
      let query = null;
      if (isAdminPage && !isAdmin) {
        route = '/reservations';
      } else if (!landingPage && !isBookingPage && !user.token) {
        route = '/login';
      } else if (user.profile.role === USER_ROLE.TEACHER && !isConfirmLessonPage) {
        route = '/teacher';
      } else if (user.profile.role === USER_ROLE.STUDENT) {
        const isUserActive = user.profile.activate;
        if (
          isUserActive &&
          (!user.profile.language || !user.profile.skypeName)
        ) {
          route = '/start';
        } else if (
          !isUserActive && !this.canUserUpsell() &&
          (this.doesUserHaveAnActiveTrial() || this.doesUserHaveASubscription())
          // TODO: Kinda silly to check the user's name here
          // We should probably just have "onBoardingStep" attribute on the user
          // this.doesUserHaveAnActiveTrial()
          // user.upsellData.status !== "WAITING" // <--- This condition redirects for the activate page, and it needs to be changed cuz it sucks
        ) {
          route = 'signup-details';
        } else if (!isUserActive) {
          if (
            location.pathname === '/activate' ||
            location.pathname === '/trial'
          ) {
            route = location.pathname;
          } else {
            // User somehow ended up somewhere else
            route = '/trial';
          }

          // Regardless of what is in the url query, force set the email to
          // the one we have in our database
          const urlParams = new URLSearchParams(window.location.search);
          urlParams.set('email', get(user, 'profile.email'));
          query = urlParams.toString();
        } else if (user.upsellData.status === 'UPSELL_1') {
          route = 'offer-47';
        } else if (user.upsellData.status === 'UPSELL_2') {
          route = 'offer-lang7';
        } else if (user.upsellData.status === 'WAITING') {
          route = '/';
        } else if (user.token && user.profile.onboard === false) {
          route = '/start';
        } else if (!isSuccessPage && user.congratsStatus === 'PENDING') {
          route = '/success';
        } else if (
          isReactivatePage &&
          isPaused &&
          user.profile.pause.paymentStatus === 'failure'
        ) {
          route = '/payment-failure';
        } else if (isPaused && !isReactivatePage) {
          route = '/reactivate';
        } else if (!isPaused && isReactivatePage) {
          route = '/schedule-lesson';
        } else if (isSuccessPage && user.congratsStatus === 'DONE') {
          route = '/schedule-lesson';
        }
      }

      if (location.pathname.indexOf(route) === -1) {
        if (query) {
          route = route + '?' + query;
        }
        this.context.router.push(route);
      }
    };

    render() {
      const { user, ...otherProps } = this.props;
      // pass the props through to the wrapped component
      return (
        <React.Fragment>
          <ComponentToWrap {...otherProps} />
          <ProfitWell
            authToken={process.env.REACT_APP_PROFITWELL_TOKEN}
            email={get(user, 'profile.email')}
          />
        </React.Fragment>
      );
    }
  }

  function mapStateToProps(state) {
    return {
      user: state.user,
    };
  }

  return compose(withRouter, connect(mapStateToProps))(Authentication);
};



// WEBPACK FOOTER //
// ./src/hocs/withAuthentication.js